import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import { Layout, Sidebar, LayoutFooter } from '@thinknet-gmbh/platform-common-ui';

import Header from 'src/components/app/header';
import { getPath } from 'src/common/helpers/get-path.helpers';
import { useCreateSupportRequest } from 'src/hooks/support-requests/create-support-request.hook';
import { useCheckIfAllowedSupportRequestCreation } from 'src/hooks/support-requests/allowed-support-request-creation.hook';

import { SIDEBAR_CONFIG } from './layout-wrapper.constants';

export const LayoutWrapper = ({
  children,
  isProtected,
}: {
  children: any;
  isProtected?: boolean;
}) => {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();

  const [sidebarCollapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const createSupportRequest = useCreateSupportRequest();
  const { allowedSupportRequestCreation } = useCheckIfAllowedSupportRequestCreation();

  const menuItems = useMemo(
    () => SIDEBAR_CONFIG.menuItems.map(item => ({ ...item, title: t(`labels.${item.title}`) })),
    [t]
  );

  return (
    <Layout>
      <Sidebar
        {...SIDEBAR_CONFIG}
        menuItems={menuItems}
        menuItemsPrimary={SIDEBAR_CONFIG.menuItemsPrimary.map(item => ({
          ...item,
          title: t(`labels.${item.title}`),
        }))}
        selectedKeys={[getPath(pathname)]}
        onItemClick={navigate}
        collapsed={sidebarCollapsed}
      />
      <Layout>
        <Header sidebarCollapsed={sidebarCollapsed} sidebarToggle={setCollapsed} />
        {children}
        {isProtected && (
          <LayoutFooter
            t={t}
            isSupportRequestExist={!allowedSupportRequestCreation}
            onSubmitRequest={({ onClose, data }) => createSupportRequest(data).then(onClose)}
          />
        )}
      </Layout>
    </Layout>
  );
};

export default LayoutWrapper;
